import { getI18nPageProps } from "@utils/translates";
import type { PageWithLayout } from "@types";
import type { GetServerSideProps } from "next";
import { setContext } from "@utils/Cookies";
import { getLayout as getDefaultLayout } from "@layouts/default-layout";
import HowToLearnSlugPage from "@features/how-to-learn/DetailPage";
import { singleHowToLearnFetchData } from "@features/how-to-learn/helpers/functions";
import { setNotFoundResponse } from "lib/ssr/not-found";

const HowToLearnDetailPage: PageWithLayout = () => {
  return <HowToLearnSlugPage />;
};

HowToLearnDetailPage.getLayout = (page, props) =>
  getDefaultLayout(
    page,
    { ...props },
    {
      footerProps: {
        showButtonOrganizationFooter: true,
      },
    }
  );

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const i18nProps = await getI18nPageProps(ctx, "howToLearn");
  setContext(ctx);
  const { query, res, req } = ctx;

  const ssrActivated =
    String(req.headers?.["x-ssr-activate"]).toLowerCase() !== "false";
  if (!ssrActivated) {
    return { props: i18nProps };
  }
  try {
    const fallback = await singleHowToLearnFetchData(query);

    return { props: { ...i18nProps, fallback } };
  } catch (error: any) {
    if (error?.error?.code === 404) setNotFoundResponse(res);
    return { props: { ...i18nProps, is404: error?.error?.code === 404 } };
  }
};

export default HowToLearnDetailPage;
